module.exports = __webpack_public_path__ + "img/33.b98bcca9.png";